import { Button, Flex, HStack, Text } from '@chakra-ui/react'
import { LuPlay } from 'react-icons/lu'
import { useTranslation } from '../../i18n'

// While paused, nothing is claimed and other moderators are covering the queue.
// That is a state worth being unmistakable about: a moderator who thinks they
// are working while their claims are released is worse than one who is idle.

export function PausedOverlay({ queueCount, onStart }) {
  const { t } = useTranslation()
  return (
    <Flex
      position="absolute"
      inset="0"
      zIndex={20}
      direction="column"
      align="center"
      justify="center"
      gap={4}
      bg="rgba(8, 12, 24, 0.82)"
      backdropFilter="blur(3px)"
    >
      <Text
        fontSize="xs"
        letterSpacing="0.2em"
        color="var(--mc-text-muted)"
        fontFamily="'JetBrains Mono', monospace"
      >
        {t('moderation.pausedTitle')}
      </Text>
      <Button size="lg" colorPalette="green" px={10} py={7} onClick={onStart}>
        <HStack gap={3}>
          <LuPlay size={22} />
          <Text fontSize="lg" fontWeight="800" letterSpacing="0.06em">
            {t('moderation.start')}
          </Text>
        </HStack>
      </Button>
      <Text fontSize="sm" color="var(--mc-text-muted)">
        {t('moderation.inQueue', { count: queueCount })}
      </Text>
    </Flex>
  )
}
